document.addEventListener('DOMContentLoaded', () => {
    const filterButtons = document.querySelectorAll('.filter-btn');
    const faqItems = document.querySelectorAll('.faq-item');
    const readMoreButton = document.querySelector('#see-more-less-btn');
    const dataItemsValue = document.querySelector('.faq-header--wrapper')?.getAttribute('data-items');
    const itemsToShow = parseInt(dataItemsValue, 10) || 6; // Default to 6 items if data-items is not set
    let currentCategory = null;
    let isExpanded = false; // To track the state of "See More" and "See Less"

    // Function to filter FAQs by category and manage visibility
    function filterFaqs(category) {
        currentCategory = category;
        isExpanded = false; // Reset the state of "See More" when filtering

        let visibleCount = 0;
        faqItems.forEach(item => {
            const itemCategory = item.getAttribute('data-category');
            const matchesFilter = itemCategory === category;

            if (matchesFilter && visibleCount < itemsToShow) {
                item.style.display = 'block';
                visibleCount++;
            } else {
                item.style.display = 'none';
            }
        });

        updateReadMoreButton(); // Update button visibility and text
    }

    // Function to toggle FAQ visibility globally
    function toggleFaqVisibility() {
        if (isExpanded) {
            filterFaqs(currentCategory); // Reapply filtering to collapse items
        } else {
            faqItems.forEach(item => {
                const itemCategory = item.getAttribute('data-category');
                if (itemCategory === currentCategory) {
                    item.style.display = 'block'; // Show all matching items
                }
            });
        }

        isExpanded = !isExpanded; // Toggle state
        updateReadMoreButton(); // Update button text
    }

    // Function to update the "See More/Less" button visibility and text
    function updateReadMoreButton() {
        const hiddenItems = Array.from(faqItems).filter(item => {
            const itemCategory = item.getAttribute('data-category');
            const matchesFilter = itemCategory === currentCategory;
            return matchesFilter && item.style.display === 'none';
        });

        if (hiddenItems.length > 0 || isExpanded) {
            readMoreButton.style.display = 'block';
            readMoreButton.textContent = isExpanded ? 'See Less' : 'See More';
        } else {
            readMoreButton.style.display = 'none';
        }
    }

    // Add click events to filter buttons
    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            filterButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            const category = button.getAttribute('data-category');
            filterFaqs(category);
        });
    });

    // Add click event to the "See More" button
    if (readMoreButton) {
        readMoreButton.addEventListener('click', () => {
            toggleFaqVisibility();
        });
    }

    // Initialize filtering on page load
    if (filterButtons.length > 0) {
        const initialCategory = filterButtons[0].getAttribute('data-category');
        filterFaqs(initialCategory);
    }
});

let faqQuestions2 = document.querySelectorAll(".faq-question");
faqQuestions2.forEach(question2 => {
    question2.addEventListener("click", event => {
        const active = document.querySelector(".faq-question.active");
        if (active && active !== question2) {
            active.classList.toggle("active");
            active.nextElementSibling.style.maxHeight = 0;
            active.nextElementSibling.classList.remove("open-accordian");
            active.parentElement.classList.remove("active-faq-item");
        }
        question2.classList.toggle("active");
        const answer = question2.nextElementSibling;
        const parent = question2.parentElement;
        if (question2.classList.contains("active")) {
            answer.style.maxHeight = answer.scrollHeight + "px";
            answer.classList.add("open-accordian");
            parent.classList.add("active-faq-item");
        } else {
            answer.style.maxHeight = 0;
            answer.classList.remove("open-accordian");
            parent.classList.remove("active-faq-item");
        }
    });
});
